export const companyHost = process.env.VUE_HOST_PACKAGE || 'nemipay';
